import { AccountMode, LicenseService, SpacetimeMode } from '../../../../../app/core/license.service';
import { IdentityService } from '../../../../../app/core/authentication/services/identity.service';
import { LicenseType } from '../../../../../app/core/authentication/models/licenses';
import {
    getDefaultSpacetimeState,
    isStateAllowedForSpacetimeMode,
} from '../../../../../app/features/spacetime/configs/spacetime-view.config';

function isSpaceScoped(transition): boolean {
    const params = transition.params();
    return !!(params && params.type && params.slug);
}

export class LicenseCheckHook {

    static $inject = ["$transitions", "LicenseService", "IdentityService"];

    constructor($transitions, licenseService: LicenseService, identityService: IdentityService) {
        $transitions.onBefore({
            to: function (state) {
                return state.data && state.data.requiredLicense;
            }
        }, function (transition) {
            const isFliptoStaff = identityService.isFliptoStaff();
            const licenseRequired = transition.to().data.requiredLicense;
            const forceForFlipto = transition.to().data.forceForFlipto;
            if (licenseService.checkLicense(licenseService.getCurrentSpaceLicenses(), licenseRequired) || (forceForFlipto && isFliptoStaff)) {
                return true;
            } else {
                transition.abort();
                transition.router.stateService.go("hub", transition.params());
            }
        });

        $transitions.onBefore({}, function (transition) {
            if (identityService.isAnonymous()) return;
            if (identityService.isFliptoStaff()) return;

            const targetName: string = transition.to().name;
            const spacetimeMode = licenseService.getSpacetimeMode();
            const isSpacetimeTarget = targetName === 'spacetime' || targetName.startsWith('spacetime.');

            // SFMC route is opt-in for non-staff: only reachable when SpacetimeMode is SFMC.
            if (targetName === 'spacetime.sfmc' && spacetimeMode !== SpacetimeMode.SFMC) {
                transition.abort();
                transition.router.stateService.go('home', transition.params());
                return;
            }

            // If the user is in a restricted SpacetimeMode (e.g. SFMC), any spacetime sub-state
            // not allowed by the mode's tabs is redirected to the mode default.
            if (isSpacetimeTarget && !isStateAllowedForSpacetimeMode(targetName, spacetimeMode)) {
                transition.abort();
                transition.router.stateService.go(getDefaultSpacetimeState(spacetimeMode), transition.params());
                return;
            }

            // AccountMode restrictions — only for SpacetimeOnly (non-Full) account access.
            if (licenseService.getAccountMode() === AccountMode.Full) return;
            if (!isSpaceScoped(transition)) return;
            if (isSpacetimeTarget) return;

            transition.abort();
            if (!licenseService.checkCurrentSpaceLicense(LicenseType.Spacetime)) {
                transition.router.stateService.go('home', transition.params());
            } else {
                transition.router.stateService.go(getDefaultSpacetimeState(spacetimeMode), transition.params());
            }
        });
    }
}
